class LogsConnect {
  constructor() {
    // Derive the backend server address from frontend URL
    const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
    const host = window.location.hostname;
    
    // Use default ports for WebSocket (443 for secure, 80 for non-secure)
    // unless explicitly configured
    let port = '';
    if (process.env.VUE_APP_BACKEND_PORT) {
      port = `:${process.env.VUE_APP_BACKEND_PORT}`;
    }
    
    // For development, use localhost with env config; otherwise use current domain
    if (process.env.NODE_ENV === 'development') {
      const wsUrl = process.env.VUE_APP_BACKEND_SOCKET_URL || 'ws://127.0.0.1';
      const devPort = process.env.VUE_APP_BACKEND_PORT || 80;
      this.baseUrl = `${wsUrl}:${devPort}`;
    } else {
      this.baseUrl = `${protocol}://${host}${port}`;
    }
  }

  // Get WebSocket URL for a specific endpoint
  getUrl(endpoint = '') {
    return `${this.baseUrl}${endpoint}`;
  }

  // Connect to WebSocket endpoint
  connect(endpoint = '') {
    return new Promise((resolve, reject) => {
      try {
        const wsUrl = this.getUrl(endpoint);
        const ws = new WebSocket(wsUrl);
        
        ws.onopen = () => {
          resolve(ws);
        };

        ws.onerror = (error) => {
          reject(error);
        };
      } catch (error) {
        reject(error);
      }
    });
  }
}

export default LogsConnect;
